import { StatusBadge, STATUS_LABEL, eur } from "@/lib/status";
import { Truck, ShoppingBag, User, MapPin, MessageCircle } from "lucide-react";

export default function OrderCard({ order, children, showEconomics, showWhatsapp }) {
  const waPhone = (order.guest_phone || "").replace(/[^0-9]/g, "");
  const waLink = waPhone
    ? `https://wa.me/${waPhone.startsWith("39") ? waPhone : "39" + waPhone}?text=${encodeURIComponent(`Ciao ${order.guest_name || ""}! Aggiornamento sul tuo ordine MorningBox ${order.code} presso ${order.vendor_name}: ${STATUS_LABEL(order.status).label}. Grazie e buona colazione!`)}`
    : null;
  return (
    <div className="bg-white rounded-2xl border border-navy/10 p-5" data-testid={`order-${order.code}`}>
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="flex items-center gap-2">
            <span className="font-heading font-bold text-navy">{order.code}</span>
            <StatusBadge status={order.status} testid={`order-status-${order.code}`} />
          </div>
          <p className="text-sm text-navy/60 mt-1">{order.package_name} · {order.persons} pers. · {order.vendor_name}</p>
        </div>
        <span className="font-bold text-orange whitespace-nowrap">{eur(order.total_price)}</span>
      </div>
      <div className="mt-3 grid grid-cols-2 gap-2 text-xs text-navy/60">
        <span className="flex items-center gap-1"><User className="w-3.5 h-3.5" />{order.guest_name || "—"}{order.room ? ` · Cam. ${order.room}` : ""}</span>
        <span className="flex items-center gap-1">{order.mode === "delivery" ? <Truck className="w-3.5 h-3.5" /> : <ShoppingBag className="w-3.5 h-3.5" />}{order.mode === "delivery" ? "Consegna" : "Ritiro"}</span>
        <span className="flex items-center gap-1"><MapPin className="w-3.5 h-3.5" />{order.date} · {order.time_slot}</span>
        <span>{order.payment_method === "stripe" ? `Carta · ${order.payment_status === "paid" ? "pagato" : "in attesa"}` : "In struttura"}</span>
      </div>
      {order.notes && <p className="mt-2 text-xs text-navy/50 bg-cream rounded-lg p-2">Note: {order.notes}</p>}
      {showEconomics && (
        <div className="mt-3 grid grid-cols-3 gap-2 text-[11px] bg-cream rounded-xl p-3">
          <div><p className="text-navy/40">Locale</p><p className="font-semibold text-navy">{eur(order.vendor_amount)}</p></div>
          <div><p className="text-navy/40">Margine B&B</p><p className="font-semibold text-navy">{eur(order.bnb_margin)}</p></div>
          <div><p className="text-navy/40">Commissione</p><p className="font-semibold text-navy">{eur(order.morningbox_commission)}</p></div>
        </div>
      )}
      {showWhatsapp && waLink && (
        <a href={waLink} target="_blank" rel="noreferrer" data-testid={`whatsapp-${order.code}`}
          className="mt-3 inline-flex items-center gap-2 text-sm font-medium text-[#128C7E] bg-[#25D366]/10 hover:bg-[#25D366]/20 rounded-full px-3 py-1.5 transition-colors">
          <MessageCircle className="w-4 h-4" /> Avvisa su WhatsApp
        </a>
      )}
      {children && <div className="mt-4">{children}</div>}
    </div>
  );
}
